var app = angular.module('directives.sendsms');

app.directive('sendsms', ['PortalApi', 'Notification',  'Restangular','$interval','$timeout','$state', 'Storage', function factory(PortalApi, Notification, Restangular,$interval,$timeout,$state, Storage) {
    return {
        restrict: 'A',
        replace: true,
        template: require('../templates/sendsms.html'),
        scope: {
            control: '='
        },
        link: function($scope, element, attrs) {

            var init = function(){
                Storage.removeItem("PayHubTIMER"+$state.current.name);

                if(!Storage.getItem("PayHubTIMER"+$state.current.name)){
                    var newTimer = new Date();

                    newTimer.setMinutes(newTimer.getMinutes()+5);
                    Storage.setItem("PayHubTIMER"+$state.current.name,newTimer);}
                    var setTimer = Storage.getItem("PayHubTIMER"+$state.current.name);
                    var timer = $interval(function () {
                    $scope.min = getTimeRemaining(setTimer).minutes;
                    $scope.sec = ('0'+getTimeRemaining(setTimer).seconds).slice(-2);

                    if(getTimeRemaining(setTimer).total <=0){
                        $scope.min = '0';
                        $scope.sec = '00';
                        $scope.control.show = true;
                        $interval.cancel(timer);


                    }
                },1000)
            };
            function getTimeRemaining(endtime){
                var t = Date.parse(endtime) - Date.parse(new Date());
                var seconds = Math.floor( (t/1000) % 60 );
                var minutes = Math.floor( (t/1000/60) % 60 );
                var hours = Math.floor( (t/(1000*60*60)) % 24 );
                var days = Math.floor( t/(1000*60*60*24) );
                return {
                    'total': t,
                    'days': days,
                    'hours': hours,
                    'minutes': minutes,
                    'seconds': seconds
                };
            }
            init();

            $scope.control.res = function () {
                $scope.control.show = false;
                Storage.removeItem("PayHubTIMER"+$state.current.name);
                init();
            }
        }
    };
}]);

module.exports = 'directives.sendsms';



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sendsms/directives/sendsms.js
 ** module id = 222
 ** module chunks = 1
 **/